import { Typography } from '@mui/material'

type FormBuilderSessionProps = {
  name: string
  label: string
  description?: string
}

export function FormBuilderSession(props: FormBuilderSessionProps) {
  return (
    <>
      <Typography key={props.name} variant="h6" style={{ margin: 0 }} gutterBottom>
        {props.label}
      </Typography>
      {props?.description && <span>{props?.description}</span>}
    </>
  )
}
